<template>
  <v-layout row wrap>
    <FilterDialog
      v-model="openFilterDialog"
      :filterOptions="filterOptions"
      :filterTypes="filterTypes"
      @filter="filterUsers"
      @apply="apply"
    />
    <v-flex xs2 sm1>
      <v-icon
        class="mt-4 mr-4 filter-icon"
        @click="openFilterDialog = !openFilterDialog"
      >
        filter_list
      </v-icon>
    </v-flex>
    <v-flex xs10 sm11 class="mt-3">
      <template v-for="(option, index) in Object.keys(filterOptions)">
        <v-chip
          close
          :key="index"
          v-if="appliedFilterTypes[`${option}_id`]"
          @input="cancelFilter(`${option}_id`)"
        >
          {{
            filterOptions[option].find(
              (value) => value.id == appliedFilterTypes[`${option}_id`]
            ).title
          }}
        </v-chip>
      </template>
    </v-flex>
  </v-layout>
</template>
<script>
  import FilterDialog from "@/components/Dialogs/FilterDialog";
  export default {
    components: {
      FilterDialog,
    },
    props: ["filterOptions"],
    data() {
      return {
        openFilterDialog: false,
        filterTypes: {},
        appliedFilterTypes: {},
        filterUrlExtension: "",
      };
    },
    watch: {
      appliedFilterTypes() {
        this.filterTypes = { ...this.appliedFilterTypes };
      },
    },

    methods: {
      makeLabel(label) {
        return label.split("_").join(" ");
      },
      filterUsers(filters) {
        this.filterTypes = { ...filters };
        this.filterUrlExtension = "";
        Object.keys(this.filterTypes).map((type) => {
          this.filterTypes[type] &&
            (this.filterUrlExtension = `${this.filterUrlExtension}&${type}=${this.filterTypes[type]}`);
        });
      },

      apply() {
        this.appliedFilterTypes = { ...this.filterTypes };
        this.$emit("apply", this.filterUrlExtension);
        this.openFilterDialog = false;
      },

      cancelFilter(filterType) {
        delete this.appliedFilterTypes[filterType];
        this.filterUsers(this.appliedFilterTypes);
        this.$emit("apply", this.filterUrlExtension);
      },
    },
  };
</script>
